<template>
  <div>
    <v-container class="mb-4" fluid>
      <div v-if="!isSmall">
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left" style="min-width: 320px">Produto</th>
              <th class="text-left" style="min-width: 120px">Qtd</th>
              <th style="min-width: 150px">Preço</th>
              <th style="min-width: 125px" v-if="!isMei">ICMS</th>
              <th style="min-width: 125px" v-if="!isMei">IPI</th>
              <th style="min-width: 100px;"></th>
            </tr>
            </thead>
            <tbody>
            <px-resposta-cadastro-produtos-table-row
              ref="produtoItem"
              v-for="(respostaProduto, index) in resposta.produtos"
              :key="index"
              :resposta-produto="respostaProduto"
              :moeda="moeda"
              :id-fornecedor="solicitacao.fornecedor.id"
              :is-mei="isMei"
              @replicar-preco="replicarPreco"
              @replicar-imposto="replicarImposto"/>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <!-- Mobile: render each product as a card using the same row component in card mode -->
      <div v-else>
        <v-row>
          <v-col cols="12" v-for="(respostaProduto, index) in resposta.produtos" :key="index">
            <px-resposta-cadastro-produtos-table-row
              ref="produtoItem"
              :resposta-produto="respostaProduto"
              :moeda="moeda"
              :id-fornecedor="solicitacao.fornecedor.id"
              :is-mei="isMei"
              :is-small="isSmall"
              @replicar-preco="replicarPreco"
              @replicar-imposto="replicarImposto"/>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-btn depressed
           color="primary"
           class="rounded-tag-small normal-btn-text"
           @click="next">
      Continuar
    </v-btn>
  </div>
</template>

<script>
import validationMixin from '@/mixins/validation-mixin';
import { NumberUtils } from 'px-components';
import { AplicacaoImposto } from 'px-business-components';
import pxRespostaCadastroProdutosTableRow
from './RespostaCadastroProdutosTableRow.vue';

export default {
  props: {
    solicitacao: Object,
    resposta: Object,
    moeda: String,
  },
  mixins: [validationMixin],
  data() {
    return {
      refs_children: [],
    };
  },
  computed: {
    isMei() {
      return !!this.solicitacao.fornecedor?.mei;
    },
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isInvalid() {
      const forms = this.refs_children.map(c => c.validateForm());
      const filesUploading = this.refs_children.map(c => c.hasFileLoading);
      if (filesUploading.find(f => f)) {
        this.$toast('Aguarde a finalização do envio do(s) arquivo(s)', { color: 'error' });
        return true;
      }
      return forms.find(form => form);
    },
  },
  methods: {
    next() {
      if (this.isInvalid) {
        return;
      }
      const hasFileLoading = this.resposta.produtos.find(p => p.$$hasFileLoading);
      if (hasFileLoading) {
        this.$toast('Aguarde o envio dos anexos e tente novamente', { color: 'warning' });
        return;
      }
      this.resposta.produtos = this.resposta.produtos.map(produto => ({
        ...produto,
        impostos: {
          ...produto.impostos,
          tipoAplicacaoIcms: produto.impostos.icms
            ? AplicacaoImposto.keys.INCLUSO.key : AplicacaoImposto.keys.ISENTO.key,
          tipoAplicacaoIpi: produto.impostos.ipi
            ? AplicacaoImposto.keys.CALCULAR.key : AplicacaoImposto.keys.ISENTO.key,
        },
      }));
      this.$emit('next');
    },
    replicarPreco(respostaProduto) {
      const precision = respostaProduto.cotacaoProduto.produto.casasDecimais ?? 2;
      const novoPreco = NumberUtils.fixNumberInput(respostaProduto.precoUnitario, false, precision);
      this.$refs.produtoItem.forEach((produto) => {
        // produtos recusados não possuem o input de preço unitário
        if (!produto.$refs.precoUnitario) {
          return;
        }
        // eslint-disable-next-line no-param-reassign
        produto.$refs.precoUnitario.$el.getElementsByTagName('input')[0].value = novoPreco;
      });
      this.resposta.produtos = this.resposta.produtos.map(produto => ({
        ...produto,
        precoUnitario: novoPreco,
      }));
    },
    replicarImposto(respostaProduto, tipoImposto) {
      const novoImposto = NumberUtils.fixNumberInput(respostaProduto.impostos[tipoImposto], true);
      this.$refs.produtoItem.forEach((produto) => {
        // produtos recusados não possuem o input de impostos
        if (!produto.$refs[tipoImposto]) {
          return;
        }
        // eslint-disable-next-line no-param-reassign
        produto.$refs[tipoImposto].$el.getElementsByTagName('input')[0].value = novoImposto;
      });
      this.resposta.produtos = this.resposta.produtos.map(produto => ({
        ...produto,
        impostos: {
          ...produto.impostos,
          [tipoImposto]: novoImposto,
        },
      }));
    },
    isEdicao() {
      return !!this.resposta.id;
    },
    retornarICMS(produto) {
      if (this.isEdicao()) {
        return produto.impostos.icms;
      }
      return produto.cotacaoProduto.produto.icms;
    },
    retornarIPI(produto) {
      if (this.isEdicao()) {
        return produto.impostos.ipi;
      }
      return produto.cotacaoProduto.produto.ipi;
    },
  },
  created() {
    this.resposta.produtos = this.resposta.produtos.map(produto => ({
      ...produto,
      impostos: {
        ...produto.impostos,
        icms: NumberUtils.fixNumberInput(this.retornarICMS(produto), true) ?? 0,
        ipi: NumberUtils.fixNumberInput(this.retornarIPI(produto), true) ?? 0,
      },
    }));
  },
  mounted() {
    this.refs_children = this.$refs.produtoItem;
  },
  components: {
    pxRespostaCadastroProdutosTableRow,
  },
};
</script>
